import { history } from "redux/configureStore";

export const doMagicLink = async (email) => {
  const encoded = btoa(email);
  const body = `{"email":"${encoded}"}`;
  const response = await fetch("/research/japi/user/magic-link-request", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body,
  });

  if (response.redirected === true) {
    window.location.assign(response.url);
  } else {
    history.push("/public/magic-link?err=fail");
  }
};
